import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import DataFlowEdit from "./data-flow-edit";

const DataFlow = ({ data }) => {
  const [isEditing, setIsEditing] = useState(false);

  const [searchParams, setSearchParams] = useSearchParams();

  const handleNextPage = () => {
    setSearchParams({ tab: "external-data" });
  };
  const handleBack = () => {
    setSearchParams({ tab: "data-collection" });
  };
  if (isEditing) {
    return <DataFlowEdit data={data} setIsEditing={setIsEditing} />;
  }
  return (
    <div className="font-Inter">
      {/* Card Header */}
      <div className="flex items-center gap-5 font-Inter">
        <h2 className=" font-semibold text-[#101828]">
          Data Flow and Visualisation
        </h2>
        <button
          onClick={() => setIsEditing(true)}
          className="text-[#2070B8] text-sm font-medium"
        >
          Edit Details
        </button>
      </div>

      {/* Card Content */}
      <div className="py-4 space-y-4">
        <div className="space-y-2">
          <label className="block text-sm font-medium text-[#3B3B3B]">
            Which department feeds data to this system *
          </label>
          <p className="text-[#667085] text-sm font-medium">
            {data?.deptsFeedDataSystem?.join(", ")}
          </p>
        </div>
        <div className="space-y-2">
          <label className="block text-sm font-medium text-[#3B3B3B]">
            Which system feeds data to this system *
          </label>
          <p className="text-[#667085] text-sm font-medium">
            {data?.systemsFeedDataSystem?.join(", ")}
          </p>
        </div>
        <div className="space-y-2">
          <label className="block text-sm font-medium text-[#3B3B3B] ">
            Which department receives data from this system?
          </label>
          <p className="text-[#667085] font-medium text-sm">
            {data?.deptReceiveData?.join(", ")}
          </p>
        </div>
        <div className="space-y-2">
          <label className="block text-sm font-medium text-[#3B3B3B]">
            Which system receives data from this system?
          </label>
          <p className="text-[#667085] text-sm font-medium">
            {data?.deptSystemReceiveData}
          </p>
        </div>

        <div className="space-y-2">
          <label className="block text-sm font-medium text-[#3B3B3B]">
            What reports are produced for decision-making?
          </label>
          <p className="text-[#667085] text-sm font-medium">
            {data?.reportProduced}
          </p>
        </div>

        {/* Action Buttons */}
        <div className="flex gap-3 pt-6">
          <button
            onClick={handleBack}
            className="px-12 py-2.5 border border-[#D0D5DD] text-[#344054] font-medium rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
          >
            Go Back
          </button>
          <button
            onClick={handleNextPage}
            className="px-12 py-2.5 bg-[#2070B8] font-medium text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
          >
            Next Page
          </button>
        </div>
      </div>
    </div>
  );
};

export default DataFlow;
